import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "grid",
  style: {"flex-wrap":"wrap"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostItem = _resolveComponent("PostItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post, index) => {
      return (_openBlock(), _createBlock(_component_PostItem, {
        key: index,
        title: post.acf.title,
        company: post.acf.company,
        oneColImage: _ctx.getPostImage(post.acf['1_column_image']),
        twoColImage: _ctx.getPostImage(post.acf['2_column_image']),
        threeColImage: _ctx.getPostImage(post.acf['3_column_image']),
        link: post.link,
        featured: post.acf.featured,
        index: Number(index),
        isLast: index === _ctx.posts?.length - 1,
        titleColor: post.acf.title_color,
        titlePosition: post.acf.title_position,
        backgroundColor: post.acf.hero_background_color,
        backgroundType: post.acf.hero_background_type
      }, null, 8, ["title", "company", "oneColImage", "twoColImage", "threeColImage", "link", "featured", "index", "isLast", "titleColor", "titlePosition", "backgroundColor", "backgroundType"]))
    }), 128))
  ]))
}